import { EmptyState } from '@components/molecules/empty-state';
import {
  dateFormat,
  defaultParams,
  pageSizeOptions,
  showSizeChanger,
  dateTimeFormat,
} from '@utils/constants';
import { ICustomer } from '@interfaces/icustomer';
import { IMeta } from '@interfaces/imeta';
import { IRecipient } from '@interfaces/irecipient';
import { ITandaTerima } from '@interfaces/itanda-terima';
import { companyTypeCase, currencyCase, orderStatusCase } from '@utils/string-case';
import { filter, tableChangeParams } from '@utils/table';
import { formatTime } from '@utils/time';
import { Table } from 'antd';
import { PaginationConfig } from 'antd/lib/table';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

interface IProps {
  isFetching: boolean;
  fetchDataSource: (params: any) => void;
  dataSource?: any;
  meta: IMeta;
}

interface IState {
  tableParams: any;
}

export class TableComponent extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      tableParams: defaultParams,
    };
  }
  public componentDidMount = () => {
    const { fetchDataSource } = this.props;
    const { tableParams } = this.state;
    fetchDataSource(tableParams);
  };
  public onChangeTable = (pagination: PaginationConfig, filters: any, sorter: any) => {
    const { fetchDataSource } = this.props;
    const { tableParams } = this.state;

    const params = tableChangeParams(pagination, filters, sorter, tableParams);
    this.setState({ tableParams: params });
    fetchDataSource(params);
  };
  public render() {
    const { dataSource, isFetching, meta } = this.props;
    const tableEmptyState = <EmptyState emptyText="Data Tidak Ditemukan" />;

    const columns: any = [
      {
        title: 'No Tanda Terima',
        dataIndex: 'code',
        ...filter('code'),
        sorter: true,
        render: (text: string, record: ITandaTerima) => (
          <Link to={`/tanda-terima/detail/${record.code}`}>{text}</Link>
        ),
        width: 180,
        fixed: 'left',
      },
      {
        title: 'No Polisi',
        dataIndex: 'vehicle.policeNo',
        ...filter('policeNo'),
        render: (text: string, record: ITandaTerima) =>
          record.vehicle ? <Link to={`/vehicle/detail/${record.vehicle.code}`}>{text}</Link> : '-',
        width: 150,
      },
      {
        title: 'No Daftar Muatan',
        dataIndex: 'dmCode',
        ...filter('dmCode'),
        sorter: true,
        render: (text: string) =>
          text ? <Link to={`/daftar-muatan/detail/${text}`}>{text}</Link> : '-',
        width: 200,
      },
      {
        title: 'No Invoice',
        dataIndex: 'invCode',
        ...filter('invCode'),
        sorter: true,
        render: (text: string) => (text ? <Link to={`/invoice/detail/${text}`}>{text}</Link> : '-'),
        width: 160,
      },
      {
        title: 'Customer',
        dataIndex: 'customer',
        ...filter('customer'),
        render: (record: ICustomer) => (
          <Link to={`/customer/detail/${record.code}`}>
            {companyTypeCase(record.type, record.name)}
          </Link>
        ),
        ellipsis: true,
      },
      {
        title: 'Kota Asal',
        dataIndex: 'warehouse.city',
        ...filter('from'),
        render: (text: string) => (text ? text : '-'),
      },
      {
        title: 'Penerima',
        dataIndex: 'recipient',
        ...filter('recipient'),
        render: (record: IRecipient) => {
          return record ? <Link to={`/recipient/detail/${record.code}`}>{record.name}</Link> : '-';
        },
        ellipsis: true,
      },
      {
        title: 'Kota Tujuan',
        dataIndex: 'recipient.city',
        ...filter('to'),
        render: (text: string) => (text ? text : '-'),
      },
      {
        title: 'Jenis Kendaraan',
        dataIndex: 'vehicle.vehicle_type.name',
        ...filter('vehicle.vehicle_type.name'),
        render: (text: string) => (text ? text : '-'),
        width: 170,
      },
      {
        title: 'Tanggal',
        dataIndex: 'orderDate',
        ...filter('dateRange'),
        sorter: true,
        render: (text: any) => (text ? formatTime(text, dateFormat) : '-'),
        width: 150,
      },
      {
        title: 'Total Harga',
        dataIndex: 'invoicePrice',
        ...filter('invoicePrice'),
        sorter: true,
        render: (text: any) => currencyCase(text) || '-',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        ...filter('status'),
        sorter: true,
        render: (text: number) => orderStatusCase(text),
      },
      {
        title: 'Diupdate Oleh',
        dataIndex: 'updated_by',
        ...filter('updated_by'),
        sorter: true,
        render: (text: string) => text || '-',
        width: 200,
      },
      {
        title: 'Diupdate Pada',
        dataIndex: 'updated_at',
        ...filter('updated_at'),
        sorter: true,
        render: (text: any) => (text ? formatTime(text, dateTimeFormat) : '-'),
        width: 200,
      },
      {
        title: 'Action',
        render: (text: any, record: ITandaTerima) => (
          <Fragment>
            <Link to={`/tanda-terima/form/${record.code}`}>Ubah</Link>
            {/* <Divider type="vertical" />
            <Button type="link">Hapus</Button> */}
          </Fragment>
        ),
        width: 200,
      },
    ];

    return (
      <div className="bt-table">
        <Table
          size="small"
          onChange={this.onChangeTable}
          columns={columns}
          dataSource={dataSource}
          bordered={true}
          pagination={
            meta && {
              current: meta.current_page,
              pageSize: meta.per_page,
              pageSizeOptions,
              showSizeChanger,
              total: meta.total,
            }
          }
          locale={{
            emptyText: tableEmptyState,
          }}
          loading={isFetching}
          scroll={{ x: 2700 }}
          rowClassName={(record: ITandaTerima) => (record.status === 1 ? 'warning' : '')}
          rowKey="id"
        />
      </div>
    );
  }
}

export default TableComponent;
